import Resources from "shared/actions/resourcesActions";

// eslint-disable-next-line import/prefer-default-export
export class CustomFieldsResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "custom_field", `/api/v1/custom_fields`);
  }
}
